import "../styles/recentprojects.css";
import project1 from "../images/screenshot1.png";
import project2 from "../images/screenshot2.png";
import project3 from "../images/screenshot3.jpg";
import project4 from "../images/project4.png";
import mixitup from "mixitup";
import { Link } from "react-router-dom";

import { HiArrowNarrowRight } from "react-icons/hi";
import { useEffect, useState } from "react";

export default function RecentProjects() {
	// mixer Portfolio
	const [worklink, setworklink] = useState("all");
	useEffect(() => {
		mixitup(".work__container", {
			selectors: {
				target: ".work__card",
			},
			animation: {
				duration: 300,
			},
		});
	}, []);

	return (
		<section className="work__section section" id="projects">
			<span className="section__subtitle">My Portfolio</span>
			<h2 className="section__title">Recent Works</h2>

			<div className="work__filters">
				<span
					className={`work__item ${worklink === "all" && "active_work"}`}
					data-filter="all"
					onClick={() => {
						setworklink("all");
					}}
				>
					All
				</span>
				<span
					className={`work__item ${worklink === "web" && "active_work"}`}
					data-filter=".web"
					onClick={() => {
						setworklink("web");
					}}
				>
					Web
				</span>
				<span
					className={`work__item ${worklink === "android" && "active_work"}`}
					data-filter=".android"
					onClick={() => {
						setworklink("android");
					}}
				>
					Android
				</span>
				<span
					className={`work__item ${worklink === "robotics" && "active_work"}`}
					data-filter=".robotics"
					onClick={() => {
						setworklink("robotics");
					}}
				>
					Robotics
				</span>
			</div>

			<div className="work__container container grid">
				<div className="work__card mix web">
					<img src={project4} alt="" className="work__img" />

					<h3 className="work__title">Youthopia2022 Website</h3>
					<p className="work__subtitle">
						Youthopia is a Annual Techno-Cultural Fest organised by DIT
						University. My job was to make a webApp with functionality of
						registering new participants and booking tickets for available
						events.
					</p>

					<div className="wbtn">
						<a
							href="https://youthopia-website.vercel.app/"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							Demo <HiArrowNarrowRight className="work__icon" />
						</a>
						<a
							href="https://github.com/Youthopia-2022/youthopiaWebsite"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							More <HiArrowNarrowRight className="work__icon" />
						</a>
					</div>
				</div>

				<div className="work__card mix web">
					<img src={project3} alt="" className="work__img" />

					<h3 className="work__title">Social Media WebApp</h3>
					<p className="work__subtitle">
						Responsive Social media application with many modern functionalies
						which includes follow/unfllow, like comment, profile-view, story
						update, user authentication etc."
					</p>

					<div className="wbtn">
						<a
							href="https://tollygram.vaibhavaswal.codes/"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							Demo <HiArrowNarrowRight className="work__icon" />
						</a>
						<a
							href="https://tollygram.vaibhavaswal.codes/"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							More <HiArrowNarrowRight className="work__icon" />
						</a>
					</div>
				</div>

				<div className="work__card mix web">
					<img src={project1} alt="" className="work__img" />

					<h3 className="work__title">Image Coloriser</h3>
					<p className="work__subtitle">
						Converts Black and White images into Colored using API from
						deepai.org
					</p>

					<div className="wbtn">
						<a
							href="https://coloriser.vaibhavaswal.codes"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							Demo <HiArrowNarrowRight className="work__icon" />
						</a>
						<a
							href="https://github.com/VaibhavAswal/ImageColoriser"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							More <HiArrowNarrowRight className="work__icon" />
						</a>
					</div>
				</div>

				<div className="work__card mix web">
					<img src={project2} alt="" className="work__img" />

					<h3 className="work__title">To Do App</h3>
					<p className="work__subtitle">
						Responsive to-do application with permanent local storage and
						weather functionality"
					</p>

					<div className="wbtn">
						<a
							href="https://vaibhavaswal.github.io/toDoApp/"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							Demo <HiArrowNarrowRight className="work__icon" />
						</a>
						<a
							href="https://github.com/VaibhavAswal/toDoApp"
							target="_blank"
							rel="noreferrer"
							className="work__button"
						>
							More <HiArrowNarrowRight className="work__icon" />
						</a>
					</div>
				</div>
			</div>
			<div className="fill">
				<Link to="/projects">
					<div className="btn">More Projects</div>
				</Link>
			</div>
		</section>
	);
}
